import { pdf } from "@react-pdf/renderer";
import ReceiptPDF from "../components/pdf/ReceiptPDF";

export default async function downloadReceipt({ invoice, organization }) {
  if (!invoice) {
    throw new Error("Missing invoice");
  }

  const blob = await pdf(<ReceiptPDF invoice={invoice} organization={organization} />).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const receiptId = invoice.invoiceNumber || invoice.id || "commande";

  link.href = url;
  link.download = `recu_${receiptId}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(url), 1000);

  return { url };
}
